// @flow
import * as React from 'react';

export const HeaderContext: React.Context<null | React.RefObject<?React.ElementRef<'header'>>> =
  React.createContext<null | React.RefObject<?React.ElementRef<'header'>>>(
    null,
  );
